import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type ShareResponse = components["schemas"]["ShareResponse"];
export type SharedConversationResponse = components["schemas"]["SharedConversationResponse"];
export type SharedConversationMessage = components["schemas"]["SharedConversationMessage"];
export type Conversation = components["schemas"]["Conversation"];

/**
 * POST /v1/chat/conversations/{id}/share — create the public link, or return the
 * existing one. The backend is idempotent: a conversation keeps the same token
 * across calls, so re-opening the share dialog never invalidates a shared link.
 */
export async function shareConversation(id: string): Promise<ShareResponse> {
  return unwrap(
    await api.POST("/v1/chat/conversations/{id}/share", { params: { path: { id } } }),
  );
}

/** DELETE /v1/chat/conversations/{id}/share — revoke the public link (unshare). */
export async function unshareConversation(id: string): Promise<void> {
  unwrap(await api.DELETE("/v1/chat/conversations/{id}/share", { params: { path: { id } } }));
}

/** GET /v1/sharing/{token} — public, read-only snapshot of a shared conversation. */
export async function getSharedConversation(token: string): Promise<SharedConversationResponse> {
  return unwrap(await api.GET("/v1/sharing/{token}", { params: { path: { token } } }));
}

/** POST /v1/sharing/{token}/fork — copy a shared conversation into the signed-in account. */
export async function forkSharedConversation(token: string): Promise<Conversation> {
  return unwrap(await api.POST("/v1/sharing/{token}/fork", { params: { path: { token } } }));
}
